import { axios_adapter, axios_adapter_without_header } from "./axios_adapter";
import ENDPOINTS, { BASE_URL_2, BASE_URL_3, BASE_URL_4 } from "./constants";
import categoriesData from "../assets/json/categories.json";
import { fetchCategories } from "../utility/jsonUtils";
import { data } from "react-router-dom";
import { get } from "react-hook-form";

const api_service = {
    signIn: async (data) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.SIGN_IN, {});
            return response;
        } catch (error) {
            return error;
        }
    },

    signOut: async () => {
        try {
            const response = await axios_adapter.post(ENDPOINTS.SIGN_OUT);
            return response.data;
        } catch (error) {
            return error;
        }
    },

    getUsers: async () => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.GET_USERS);
            return response.data;
        } catch (error) {
            return error;
        }
    },

    getUser: async (id) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.GET_USER(id));
            return response.data;
        } catch (error) {
            return error;
        }
    },

    getCategories: async () => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.GET_GENERS);
            return response.data;
        } catch (error) {
            return error;
        }
    },

    getSubcategories: async (categoryId) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.GET_SUBCATEGORIES(categoryId));
            return response.data;
        }
        catch (error) {
            return error;
        }
    },

    getQuestions: async () => {
        try {
            const params = { page: 1, limit: 200 };
            const response = await axios_adapter.get(ENDPOINTS.GET_QUESTIONS, { params });
            return response.data;
        }
        catch (error) {
            return error;
        }
    },

    updateQuestionStatus: async ({ questionId, nextStatus }) => {
        try {
            console.log("questionId : ", questionId)
            console.log("params : ", nextStatus)
            const params = { status: nextStatus }
            const response = await axios_adapter.put(ENDPOINTS.UPDATE_QUESTION_STATUS(questionId), params);
            return response;
        }
        catch (error) {
            return error;
        }
    },

    createQuestion: async ({data}) => {
        try {
            const response = await axios_adapter.post(ENDPOINTS.CREATE_QUESTION_NEW, data);
            return response.data;
        }
        catch (error) {
            return error;
        }
    },

    updateQuestion: async ({ questionId, data }) => {
        try {
            console.log("questionId : ", questionId)
            console.log("data : ", data)
            const response = await axios_adapter.put(ENDPOINTS.UPDATE_QUESTION_NEW(questionId), data);
            return response.data;
        }
        catch (error) {
            return error;
        }
    },

    deleteQuestion: async ({ questionId }) => {
        try {
            console.log("questionId : ", questionId)
            const response = await axios_adapter.delete(ENDPOINTS.DELETE_QUESTION(questionId));
            return response;
        }
        catch (error) {
            return error;
        }
    },

    getGames: async (_page, _limit) => {
        try {
            const params = { page: _page, limit: _limit };
            const response = await axios_adapter.get(ENDPOINTS.GET_GAMES, { params });
            return response.data;
        } catch (error) {
            console.error("GET_GAMES error:", error?.errors || error.message);
            return error;
        }
    },

    getGame: async (gameType, gameId) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.GET_GAME(gameId));
            return response.data;
        } catch (error) {
            console.error("GET_GAME error:", error?.errors || error.message);
            return error;
        }
    },

    createGame: async (data) => {
        try {
            const customData = {
                "type": "predictionBased",
                "status": "active",
                "title": "Title",
                "subTitle": "Subtitle",
                "banner": "https://fastly.picsum.photos/id/17/400/100.jpg?hmac=EY9k-fT6I_0Z9CwXLQmvc_cZbQksLGHqiddNyaMAYQ0",
                "rules": {
                    "termsConditionsUrl": "https://www.google.com/",
                    "sourceOfTruthUrl": "https://www.google.com/",
                    "aboutGame": "About Game",
                    "rules": "Contest Rules",
                    "sourceOfTruth": "Source of Truth",
                    "goLiveAt": 1753749000,
                    "submissionCutOffAt": 1753835400,
                    "resultDeclarationAt": 1753835700
                },
                "anchor": {
                    "type": "show",
                    "id": "68638e804e60115ecb26a6a1"
                },
                "question": {
                    "questionText": "Which Image is blur ?",
                    "status": "",
                    "multimedia": {
                        "mediaType": "",
                        "url": "",
                        "aspectRatio": ""
                    },
                    "options": [
                        {
                            "id": "",
                            "text": "Answer 1",
                            "label": "A",
                            "multimedia": {
                                "mediaType": "image",
                                "url": "https://fastly.picsum.photos/id/441/200/300.jpg?blur=5&hmac=c-DAqfLDoy57gHa1FtOcshZ-4IewbN5DgOULnxT0thE",
                                "aspectRatio": "1:1"
                            }
                        },
                        {
                            "id": "",
                            "text": "Answer 2",
                            "label": "B",
                            "multimedia": {
                                "mediaType": "image",
                                "url": "https://fastly.picsum.photos/id/250/200/300.jpg?grayscale&hmac=OxHZnyjDr5GrB-xN4f5Ry37YBxRFTqYiBMR6A30Iec8",
                                "aspectRatio": "1:1"
                            }
                        },
                        {
                            "id": "",
                            "text": "Answer 3",
                            "label": "C",
                            "multimedia": {
                                "mediaType": "image",
                                "url": "https://fastly.picsum.photos/id/237/200/300.jpg?hmac=TmmQSbShHz9CdQm0NkEjx1Dyh_Y984R9LpNrpvH2D_U",
                                "aspectRatio": "1:1"
                            }
                        },
                        {
                            "id": "",
                            "text": "Answer 4",
                            "label": "D",
                            "multimedia": {
                                "mediaType": "image",
                                "url": "https://fastly.picsum.photos/id/476/200/200.jpg?hmac=QPKhNReQFJilT6PFUwm33_xa1DiivT32FbsWYE4evPU",
                                "aspectRatio": "1:1"
                            }
                        }
                    ],
                    "answer": {
                        "id": ""
                    }
                },
                "forkContestRules": [
                    {
                        "ticketPrice": {
                            "money": {
                                "value": 50,
                                "currency": "inr"
                            },
                            "rapCoin": 0
                        },
                        "win": {
                            "prizePoolShare": 1,
                            "winPositions": [
                                {
                                    "position": 1,
                                    "share": 0.5
                                },
                                {
                                    "position": 2,
                                    "share": 0.3
                                },
                                {
                                    "position": 3,
                                    "share": 0.2
                                }
                            ]
                        },
                        "contestType": "Paid",
                        "isPromoted": false,
                        "ruleId": "",
                        "maxSpots": 3,
                        "minSpots": 2,
                        "lobbyTime": 0
                    }
                ]
            }
            //console.log("Payload to CREATE_GAME:", data);
            const response = await axios_adapter.post(ENDPOINTS.CREATE_GAME, data);
            return response.data;
        } catch (error) {
            console.error("CREATE_GAME error:", error?.errors || error.message);
            return error;
        }
    },

    updateGame: async (data) => {
        try {
            const response = await axios_adapter.put(ENDPOINTS.UPDATE_GAME(data?._id), data);
            return response.data;
        } catch (error) {
            console.error("UPDATE_GAME error:", error?.errors || error.message);
            return error;
        }
    },

    deleteGame: async (gameId) => {
        try {
            const response = await axios_adapter.delete(ENDPOINTS.DELETE_GAME(gameId));
            return response.data;
        } catch (error) {
            console.error("DELETE_GAME error:", error?.errors || error.message);
            return error;
        }
    },

    releaseAnswerGame: async ({ questionId, requestPayload }) => {
        try {
            //const params = { optionId: answerId };
            const response = await axios_adapter.put(ENDPOINTS.RELEASE_ANSWER_GAME(questionId), requestPayload);
            return response.data;
        } catch (error) {
            console.error("DELETE_GAME error:", error?.errors || error.message);
            return error;
        }
    },

    getShows: async () => {
        try {
            const params = { show: "all" };
            const response = await axios_adapter.get(ENDPOINTS.GET_SHOWS, { params });
            return response.data;
        } catch (error) {
            console.error("GET_SHOWS error:", error?.errors || error.message);
            return error;
        }
    },

    getAnchorCategory: async () => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.GET_ANCHOR_CATEGORIES);
            return response.data;
        } catch (error) {
            console.error("GET_ANCHOR_CATEGORIES error:", error?.errors || error.message);
            return error;
        }
    },

    getEntities: async (_page, _limit, _displayName, _type, _language, _country, _year) => {
        try {
            let params = {};
            //{ page: _page, limit: _limit };
            if (_displayName) {
                params = { ...params, displayName: _displayName }
            }
            if (_type) {
                params = { ...params, type: _type }
            }
            if (_language) {
                params = { ...params, language: _language }
            }
            if (_country) {
                params = { ...params, country: _country }
            }
            if (_year) {
                params = { ...params, year: _year }
            }
            if (Object.keys(params).length > 0) {
                params = { ...params, page: _page, limit: _limit }
            }
            else {
                params = { page: _page, limit: _limit }
            }
            const response = await axios_adapter.get(ENDPOINTS.GET_ENTITIES, { params });
            return response.data;
        } catch (error) {
            console.error("GET_ENTITIES error:", error?.errors || error.message);
            return error;
        }
    },

    getAllMultiMediaList: async () => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.MULTIMEDIA_LIST);
            return response.data;
        } catch (error) {
            console.error("MULTIMEDIA_LIST error:", error?.errors || error.message);
            return error;
        }
    },

    getMultiMediaList: async (entityId) => {
        try {
            if (!entityId || typeof entityId !== "string" || entityId?.trim() === "") {
                console.warn("getMultiMediaList skipped: invalid entityId");
                return { error: "Invalid entityId" };
            }

            const response = await axios_adapter.get(ENDPOINTS.MULTIMEDIA_LIST_BY_ENTITY_ID(entityId));
            return response.data;
        } catch (error) {
            console.error("MULTIMEDIA_LIST_BY_ENTITY_ID error:", error?.errors || error.message);
            return error;
        }
    },

    getMultiMediaDetail: async (mediaId) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.MULTIMEDIA_DETAIL(mediaId));
            return response.data;
        } catch (error) {
            console.error("MULTIMEDIA_DETAIL error:", error?.errors || error.message);
            return error;
        }
    },

    deleteMultiMedia: async (mediaId) => {
        try {
            const response = await axios_adapter.delete(ENDPOINTS.MULTIMEDIA_DELETE(mediaId));
            return response.data;
        } catch (error) {
            console.error("MULTIMEDIA_DELETE error:", error?.errors || error.message);
            return error;
        }
    },

    createMultiMedia: async (data) => {
        try {
            const response = await axios_adapter.post(ENDPOINTS.MULTIMEDIA_CREATE, data);
            return response.data;
        } catch (error) {
            console.error("MULTIMEDIA_CREATE error:", error?.errors || error.message);
            return error;
        }
    },

    editMultiMedia: async (mediaId, data) => {
        console.log("mediaId : ", mediaId);
        console.log("data : ", data);
        try {
            const response = await axios_adapter.post(ENDPOINTS.MULTIMEDIA_EDIT(mediaId), data);
            return response.data;
        } catch (error) {
            console.error("MULTIMEDIA_EDIT error:", error?.errors || error.message);
            return error;
        }
    },

    getEntity: async (gameId) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.GET_ENTITY(gameId));
            return response.data?.[0];
        } catch (error) {
            console.error("GET_ENTITY error:", error?.errors || error.message);
            return error;
        }
    },

    getEntityGlobals: async () => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.GET_ENTITY_GLOBALS);
            return response.data;
        } catch (error) {
            console.error("GET_GLOBALS error:", error);
            return error;
        }
    },

    createEntity: async (data) => {
        try {
            //console.log("Payload to CREATE_GAME:", data);
            const response = await axios_adapter.post(ENDPOINTS.CREATE_ENTITY, data);
            return response.data;
        } catch (error) {
            console.error("CREATE_ENTITY error:", error?.errors || error.message);
            return error;
        }
    },

    updateEntity: async (data) => {
        try {
            const response = await axios_adapter.put(ENDPOINTS.UPDATE_ENTITY(data?._id), data);
            return response.data;
        } catch (error) {
            console.error("UPDATE_ENTITY error:", error?.errors || error.message);
            return error;
        }
    },

    deleteEntity: async (gameId) => {
        try {
            const response = await axios_adapter.delete(ENDPOINTS.DELETE_ENTITY(gameId));
            return response.data;
        } catch (error) {
            console.error("DELETE_ENTITY error:", error?.errors || error.message);
            return error;
        }
    },

    getArtists: async (params) => {
        try {

            const response = await axios_adapter.get(ENDPOINTS.GET_ARTISTS, { params });
            return response.data;
        } catch (error) {
            console.error("GET_ARTISTS error:", error?.errors || error.message);
            return error;
        }
    },

    createQuestionsBankForEntity: async (params) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.CREATE_QUESTION_BANK,
                {
                    params,
                    baseURL: BASE_URL_4,
                });
            return response.data;
        } catch (error) {
            console.error("DELETE_ENTITY error:", error?.errors || error.message);
            return error;
        }
    },

    createFLRealGame: async (data) => {
        try {
            const response = await axios_adapter.post(ENDPOINTS.FL_REAL_CREATE_GAME, data, { baseURL: BASE_URL_3 });
            return response.data;
        } catch (error) {
            console.error("FL_REAL_CREATE_GAME error:", error?.errors || error.message);
            return error;
        }
    },

    updateFLRealGame: async (gameId, data) => {
        try {
            const response = await axios_adapter.post(ENDPOINTS.FL_REAL_UPDATE_GAME(gameId), data, { baseURL: BASE_URL_3 });
            return response.data;
        } catch (error) {
            console.error("FL_REAL_CREATE_GAME error:", error?.errors || error.message);
            return error;
        }
    },

    getFLRealGameDetails: async (gameId) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.FL_REAL_GAME_DETAILS(gameId), { baseURL: BASE_URL_3 });
            return response.data;
        } catch (error) {
            console.error("FL_REAL_GAME_DETAILS error:", error?.errors || error.message);
            return error;
        }
    },

    submitFLRealStats: async ({ gameId, data }) => {
        try {
            if (!gameId || typeof gameId !== "string" || gameId?.trim() === "") {
                console.warn("submitFLRealStats skipped: invalid gameId");
                return { error: "Invalid gameId" };
            }

            if (!data || typeof data !== "object" || Object.keys(data)?.length === 0) {
                console.warn("submitFLRealStats skipped: empty or invalid data");
                return { error: "Invalid data" };
            }

            const response = await axios_adapter.post(ENDPOINTS.FL_REAL_SUBMIT_STATS(gameId), data, { baseURL: BASE_URL_3 });
            return response.data;
        } catch (error) {
            console.error("FL_REAL_SUBMIT_STATS error:", error?.errors || error.message);
            return error;
        }
    },

    getStats: async () => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.getStats, { baseURL: BASE_URL_3 });
            return response.data;
        } catch (error) {
            console.error("getStats error:", error?.errors || error.message);
            return error;
        }
    },

    getActiveStatsEntity: async () => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.getActiveStatsEntity, { baseURL: BASE_URL_3 });
            return response.data;
        } catch (error) {
            console.error("getActiveStatsEntity error:", error?.errors || error.message);
            return error;
        }
    },

    submitStats: async (data) => {

        try {
            const response = await axios_adapter.post(ENDPOINTS.submitStats, data, { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            console.error("submitStats error:", error?.errors || error.message);
            return error;
        }
    },

    getTambolaMultimediaList: async ({ _page, _limit }) => {
        try {
            console.log("_page : ", _page)
            console.log("_limit : ", _limit)
            const params = { page: _page, limit: _limit };
            const response = await axios_adapter.get(ENDPOINTS.getTambolaMultimediaList, { params: params, baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getTambolaMultimediaDetail: async ({ id }) => {
        try {
            console.log("id : ", id)
            const response = await axios_adapter.get(ENDPOINTS.getTambolaMultimediaDetail(id), { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    addTambolaMultimedia: async (data) => {
        try {
            const response = await axios_adapter.post(ENDPOINTS.addTambolaMultimediaList, data, { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            return error;
        }
    },

    editTambolaMultimedia: async ({ id, data }) => {
        try {
            console.log("data : ", data)
            const response = await axios_adapter.post(ENDPOINTS.editTambolaMultimediaList(id), data, { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            return error;
        }
    },

    getTambolaGamesList: async ({ _page, _limit }) => {
        try {
            console.log("_page : ", _page)
            console.log("_limit : ", _limit)
            const params = { page: _page, limit: _limit };
            const response = await axios_adapter.get(ENDPOINTS.getTambolaGamesList, { params: params, baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getTambolaGameDetail: async ({ gameId }) => {
        try {
            console.log("gameId : ", gameId)
            const response = await axios_adapter.get(ENDPOINTS.getTambolaGameDetail(gameId), { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    createTambolaGames: async ({ data }) => {
        try {
            console.log("data : ", data)
            const response = await axios_adapter.post(ENDPOINTS.createTambolaGame, data, { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            return error;
        }
    },

    editTambolaGames: async ({ id, data }) => {
        try {
            console.log("id : ", id)
            console.log("data : ", data)
            const response = await axios_adapter.post(ENDPOINTS.editTambolaGame(id), data, { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            return error;
        }
    },

    pushImportCSVEntity: async ({ data }) => {
        try {
            console.log("data : ", data)
            const response = await axios_adapter.post(ENDPOINTS.pushImportCSVEntity, data, { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            return error;
        }
    },

    pushImportCSVFantasy: async ({ data }) => {
        try {
            console.log("data : ", data)
            const response = await axios_adapter.post(ENDPOINTS.pushImportCSVFantasy, data, { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            return error;
        }
    },

    pushImportCSVFantasyStats: async ({ data }) => {
        try {
            console.log("data : ", data)
            const response = await axios_adapter.post(ENDPOINTS.pushImportCSVFantasyStats, data, { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            return error;
        }
    },

    pushImportCSVHousie: async ({ data }) => {
        try {
            console.log("data : ", data)
            const response = await axios_adapter.post(ENDPOINTS.pushImportCSVHousie, data, { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            return error;
        }
    },

    processTambolaVideo: async () => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.processTambolaVideo, {
                baseURL: BASE_URL_3,
                timeout: 180000,
            });
            return response;
        } catch (error) {
            return error;
        }
    },

    getCsvBatchList: async () => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.csvBatchList, { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            return error;
        }
    },

    getCsvBatchDetail: async ({ batchId }) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.csvBatchDetail(batchId), { baseURL: BASE_URL_3 });
            return response;
        } catch (error) {
            return error;
        }
    },

    getClientDeletedUsersList: async ({ params }) => {
        try {
            const response = await axios_adapter_without_header.get(ENDPOINTS.clientDeletedUserList, { params: params, baseURL: BASE_URL_4 });
            return response;
        } catch (error) {
            return error;
        }
    },

    deleteClientUser: async ({ userId }) => {
        try {
            const response = await axios_adapter_without_header.put(ENDPOINTS.deleteClientUserFromAWS(userId), { baseURL: BASE_URL_4 });
            return response;
        } catch (error) {
            return error;
        }
    },

    pushImportCSVQuestioBank: async ({ data }) => {
        try {
            console.log("data : ", Array.isArray(data) ? `array(${data.length})` : data);
            if (!Array.isArray(data) || data.length === 0) {
                return {
                    responseCode: 400,
                    data: null,
                    error: { message: 'Request body cannot be empty', errorCode: -1 },
                };
            }
            const response = await axios_adapter.post(ENDPOINTS.csvQuestionBank, data, {
                baseURL: BASE_URL_3,
                timeout: 300000,
            });
            return response;
        } catch (error) {
            return error?.response || error;
        }
    },

    getCurrencyTransactions: async (params) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.CURRENCY_TXN_LIST, { params, baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getSalesTransactions: async (params) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.SALES_TXN_LIST, { params, baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getRapshortsList: async (params) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.RAPSHORTS_LIST, { params, baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getRapshortDetail: async ({ shortId }) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.RAPSHORTS_DETAIL(shortId), { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    createRapshort: async (data) => {
        try {
            const response = await axios_adapter.post(ENDPOINTS.RAPSHORTS_CREATE, data, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    editRapshort: async ({ shortId, data }) => {
        try {
            const response = await axios_adapter.put(ENDPOINTS.RAPSHORTS_EDIT(shortId), data, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    updateRapshortStatus: async ({ shortId, status }) => {
        try {
            const payload = { status };
            const response = await axios_adapter.put(ENDPOINTS.RAPSHORTS_STATUS_UPDATE(shortId), payload, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    deleteRapshort: async ({ shortId }) => {
        try {
            const response = await axios_adapter.delete(ENDPOINTS.RAPSHORTS_DELETE(shortId), { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getUgcList: async (params) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.UGC_LIST, { params, baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    approveUgcClip: async ({ clipId }) => {
        try {
            const response = await axios_adapter.post(ENDPOINTS.UGC_APPROVE(clipId), {}, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    rejectUgcClip: async ({ clipId, reason }) => {
        try {
            const payload = { reason };
            const response = await axios_adapter.post(ENDPOINTS.UGC_REJECT(clipId), payload, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    publishUgcClip: async ({ clipId, gameId }) => {
        try {
            const payload = { gameId };
            const response = await axios_adapter.post(ENDPOINTS.UGC_PUBLISH(clipId), payload, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    updateUgcStatus: async ({ clipId, status }) => {
        try {
            const payload = { status };
            const response = await axios_adapter.post(ENDPOINTS.UGC_STATUS_UPDATE(clipId), payload, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getUgcDetail: async ({ clipId }) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.UGC_DETAIL(clipId), { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    uploadContentIDSheet: async (data) => {
        try {
            console.log("data : ", data)
            const response = await axios_adapter.post(ENDPOINTS.uploadContentIDSheet, data, { baseURL: BASE_URL_4 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getQuestionsNew: async (params) => {
        try {
            console.log("page : ", params.page)
            console.log("limit : ", params.limit)
            console.log("search : ", params.search)
            // const params = { page: params.page, limit: params.limit, search: params.search };
            //const params = { page: params.page, limit: params.limit };
            const response = await axios_adapter.get(ENDPOINTS.GET_QUESTIONS_NEW, { params: params });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getQuestionFilterNew: async () => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.GET_QUESTION_FILTER_NEW);
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getQuestionDetailNew: async ({ questionId }) => {
        try {
            console.log("questionId : ", questionId)
            const response = await axios_adapter.get(ENDPOINTS.GET_QUESTION_DETAIL_NEW(questionId), { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getVimeoIDorContentIDDetail: async ({ vimeoId, contentId }) => {
        try {
            console.log("vimeoId : ", vimeoId)
            console.log("contentId : ", contentId)
            const params = {};
            if (vimeoId) {
                params.vimeoId = vimeoId;
            }
            if (contentId) {
                params.contentId = contentId;
            }
            const response = await axios_adapter.get(ENDPOINTS.GET_VIMEO_OR_CONTENT_ID_DETAIL, { params, baseURL: BASE_URL_4 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    createQuestionNew: async (data) => {
        try {
            console.log("Payload to CREATE_QUESTION_NEW:", data);
            const response = await axios_adapter.post(ENDPOINTS.CREATE_QUESTION_NEW, data, { baseURL: BASE_URL_4 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    updateQuestionStatusNew: async ({ questionId, status }) => {
        try {
            console.log("questionId : ", questionId)
            console.log("nextStatus : ", status)
            const params = { status: status }
            const response = await axios_adapter.put(ENDPOINTS.UPDATE_QUESTION_STATUS_NEW(questionId), params, { baseURL: BASE_URL_4 });
            return response;
        } catch (error) {
            return error;
        }   
    },

    updateQuestionNew: async ({ questionId, data }) => {
        try {
            console.log("questionId : ", questionId)
            console.log("data : ", data)
            const response = await axios_adapter.put(ENDPOINTS.UPDATE_QUESTION_NEW(questionId), data, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getFeedbackFormsList: async (params) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.FEEDBACK_FORMS_LIST, { params, baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    createFeedbackForm: async (data) => {
        try {
            const response = await axios_adapter.post(ENDPOINTS.FEEDBACK_FORMS_CREATE, data, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getFeedbackFormDetail: async (id) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.FEEDBACK_FORMS_DETAIL(id), { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    updateFeedbackForm: async ({ id, data }) => {
        try {
            const response = await axios_adapter.put(ENDPOINTS.FEEDBACK_FORMS_UPDATE(id), data, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    deleteFeedbackForm: async (id) => {
        try {
            const response = await axios_adapter.delete(ENDPOINTS.FEEDBACK_FORMS_DELETE(id), { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    publishFeedbackForm: async (id) => {
        try {
            const response = await axios_adapter.post(ENDPOINTS.FEEDBACK_FORMS_PUBLISH(id), {}, { baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getFeedbackFormResponses: async ({ id, params }) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.FEEDBACK_FORMS_RESPONSES(id), { params, baseURL: BASE_URL_3 });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getFeedbackResponseDetail: async ({ id, responseId }) => {
        try {
            const response = await axios_adapter.get(ENDPOINTS.FEEDBACK_FORMS_RESPONSE_DETAIL(id, responseId), {
                baseURL: BASE_URL_3,
            });
            return response?.data;
        } catch (error) {
            return error;
        }
    },

    getPublicFeedbackForm: async (slug, token) => {
        try {
            const headers = {};
            const params = {};
            if (token) {
                // Prefer Authorization; also send ?token= for share-link compatibility
                headers.Authorization = `Bearer ${token}`;
                params.token = token;
            }
            const response = await axios_adapter_without_header.get(ENDPOINTS.FEEDBACK_PUBLIC_FORM(slug), {
                baseURL: BASE_URL_3,
                headers,
                params,
            });
            return response?.data;
        } catch (error) {
            return error?.response?.data || error;
        }
    },

    submitPublicFeedback: async (slug, data, bearerToken) => {
        try {
            const headers = {};
            const params = {};
            if (bearerToken) {
                headers.Authorization = `Bearer ${bearerToken}`;
                params.token = bearerToken;
            }
            const response = await axios_adapter_without_header.post(
                ENDPOINTS.FEEDBACK_PUBLIC_SUBMIT(slug),
                data,
                { baseURL: BASE_URL_3, headers, params }
            );
            return response?.data;
        } catch (error) {
            return error?.response?.data || error;
        }
    },
};

export default api_service;